
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/meno-digital-menu",
      function () {
        return require("private-next-pages/[lang]/meno-digital-menu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/meno-digital-menu"])
      });
    }
  